var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"card-content"},[(_vm.siteId && Object.keys(_vm.selectedSettingsSite).length)?_c('message-settings-for-site',{attrs:{"site":_vm.selectedSettingsSite}}):_vm._e()],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"card-header-title"},[_vm._v("Alarm schedules and settings")])])
}]

export { render, staticRenderFns }